// src/config/conceptoAutocompleteColors.js
// Colores de fondo por producto en el autocompletado de conceptos.
//
// La paleta base cubre los productos que hoy devuelve ConceptoGasto/Consultar.
// Cualquier producto nuevo recibe color automático, para que no haya que
// recordar actualizar este archivo cada vez que Cryoinfra agregue uno.

export const PALETA_BASE = {
  'CO2': '#e3f2fd', // Azul pastel
  'LIN': '#e8f5e9', // Verde pastel
  'LOX': '#fff3e0', // Naranja pastel
  'LAR': '#f3e5f5', // Morado pastel
  'H2': '#ffebee',  // Rojo pastel
  'LHY': '#e0f7fa', // Cian pastel — hidrógeno líquido
  'N/A': '#f5f5f5', // Gris pastel
};

// Colores para productos que aún no tienen uno asignado a mano.
export const PALETA_EXTRA = [
  '#fce4ec',
  '#e8eaf6',
  '#f1f8e9',
  '#fff8e1',
  '#efebe9',
  '#e0f2f1',
];

/**
 * Construye el mapa de colores a partir de los productos del catálogo.
 *
 * @param {Array<Object>} conceptos Respuesta de ConceptoGasto/Consultar.
 * @returns {Object} Mapa de código de producto a color hexadecimal.
 */
export const construirColoresPorProducto = (conceptos = []) => {
  const colores = { ...PALETA_BASE };
  if (!Array.isArray(conceptos)) return colores;

  const productos = [
    ...new Set(conceptos.map((concepto) => concepto?.Producto).filter(Boolean)),
  ].sort();

  let siguiente = 0;
  productos.forEach((producto) => {
    if (!colores[producto]) {
      colores[producto] = PALETA_EXTRA[siguiente % PALETA_EXTRA.length];
      siguiente += 1;
    }
  });

  return colores;
};

// Se conserva la exportación anterior para no romper importaciones existentes.
export const CONCEPTO_AUTOCOMPLETE_PRODUCT_BACKGROUND_COLORS = PALETA_BASE;
